// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgGif: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, title, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      {...props}
    >
      <title>{title}</title>
      <path
        fill={secondary ?? 'transparent'}
        d="M.401 4.289C.646 2.208 2.208.646 4.29.401 6.086.19 8.636 0 12 0c3.52 0 6.149.208 7.956.43 1.945.24 3.412 1.66 3.647 3.607.21 1.74.397 4.316.397 7.963 0 3.818-.206 6.461-.427 8.202-.23 1.81-1.56 3.14-3.371 3.371-1.74.221-4.384.427-8.202.427-3.648 0-6.223-.188-7.963-.397C2.09 23.368.67 21.9.43 19.956.208 18.15 0 15.52 0 12c0-3.364.19-5.914.401-7.711"
      />
      <path
        fill={primary ?? fill ?? 'currentColor'}
        fillRule="evenodd"
        d="M4.289.401C2.208.646.646 2.208.401 4.29.19 6.086 0 8.636 0 12c0 3.52.208 6.149.43 7.956.24 1.945 1.66 3.412 3.607 3.647 1.74.21 4.315.397 7.963.397 3.818 0 6.461-.206 8.202-.427 1.81-.23 3.14-1.56 3.371-3.371.221-1.74.427-4.384.427-8.202 0-3.647-.188-6.223-.397-7.963C23.368 2.09 21.9.67 19.956.43 18.15.208 15.52 0 12 0 8.636 0 6.086.19 4.289.401m6.424 14.79c-.807.902-1.934 1.495-3.37 1.495-2.314 0-4.213-1.614-4.213-4.106 0-2.504 1.899-4.094 4.213-4.094 1.65 0 2.682.831 3.275 1.768l-1.4.76a2.241 2.241 0 0 0-1.875-1.032c-1.436 0-2.48 1.103-2.48 2.598 0 1.495 1.044 2.6 2.48 2.6.7 0 1.365-.31 1.685-.606v-.95H6.94v-1.47h3.773zm3.026-6.574v7.915h-1.685V8.617zm3.252 4.64v3.275h-1.685V8.617h5.6V10.1h-3.915v1.673h3.832v1.484z"
        clipRule="evenodd"
      />
    </svg>
  );
};

const Memo = memo(SvgGif);
export default Memo;
